import { DISMISSED_APP_BUILD_ID_STORAGE_KEY } from "@/constants/app-update";

interface IWriteDismissedAppBuildIdProps {
  buildId: string;
}

// NOTE: NSAI-8170 — storage can throw (blocked site data, some private
// modes). Losing it only means a closed toast comes back on the next check,
// so a failure is swallowed rather than allowed to break the app shell.
export const readDismissedAppBuildId = (): string | null => {
  try {
    return sessionStorage.getItem(DISMISSED_APP_BUILD_ID_STORAGE_KEY);
  } catch {
    return null;
  }
};

export const writeDismissedAppBuildId = ({
  buildId,
}: IWriteDismissedAppBuildIdProps): void => {
  try {
    sessionStorage.setItem(DISMISSED_APP_BUILD_ID_STORAGE_KEY, buildId);
  } catch {
    // NOTE: see readDismissedAppBuildId — the toast simply returns.
  }
};
